// extracted by mini-css-extract-plugin
export default {"AcknowledgeDeleteContainer":"AcknowledgeDelete_AcknowledgeDeleteContainer__NrOOz"};